let grid: any = {
	baselineHeight: 22,
	columns: 12,
	baselineToGutterRatio: 2
};

grid.gutterWidth = grid.baselineToGutterRatio * grid.baselineHeight;

export default grid;
